/**
 * rutaDeVuelta — valida el parámetro `?volver=` antes de navegar a él.
 *
 * ── ESTO ES UNA PROTECCIÓN CONTRA UN REDIRECT ABIERTO ─────────────────────────────────────────
 *
 * La ficha de la persona acepta `?volver=<ruta>` para que, al guardar, vuelvas al proceso de alta
 * o de baja del que venías (FASE_PANTALLA_DE_ALTA_Y_BAJA.md, §6, pieza 2). Ese valor viene en la
 * URL, así que lo puede escribir CUALQUIERA: basta con mandar un enlace a la intranet que lleve
 * `?volver=https://otra-web`. Sin esta comprobación, quien lo abre, guarda la ficha y acaba en una
 * web ajena que se parece a la intranet y le pide la contraseña. Eso es un **redirect abierto**:
 * nuestra URL, de confianza, usada para llevar a otro sitio.
 *
 * Por eso sólo se acepta una RUTA DE ESTA APLICACIÓN, y todo lo demás se ignora (devuelve `null`,
 * y quien llama hace lo de siempre: ir al listado):
 *
 *   · tiene que empezar por UNA barra         `/gestionpersonas/...`
 *                                              rechaza `https://otra.web`, `javascript:...`, `otra.web`
 *   · y no por dos                             rechaza `//otra.web`, que el navegador lee como OTRO
 *                                              dominio con el mismo protocolo
 *   · sin barra invertida ni espacios          rechaza `/\otra.web` y `/<tab>/otra.web`: el navegador
 *                                              normaliza `\` a `/` y quita tabuladores y saltos, y
 *                                              los dos acaban siendo `//otra.web`
 *   · y con un largo razonable                 una ruta nuestra no pasa de unos pocos cientos
 *
 * No se relaja «porque react-router ya navega dentro»: uno de los dos sitios que la usan,
 * `VentanaEmergente.js`, sale con `window.location.href`, que va a donde le digan.
 */
export function rutaDeVuelta(valor) {
  if (typeof valor !== 'string' || valor.length === 0 || valor.length > 500) return null;
  if (!valor.startsWith('/')) return null;
  if (valor.startsWith('//')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\\\s\u0000-\u001f\u007f]/.test(valor)) return null;
  return valor;
}
